<!-- https://iconify.design/icon-sets/heroicons-solid/menu.html -->
<svg {...$$props} viewBox="0 0 20 20" fill="currentColor">
  <path
    d="M3 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm0 5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z"
  />
</svg>
